// src/utils/config.js
export const AUTH0 = {
  domain: import.meta.env.REACT_APP_AUTH0_DOMAIN,
  clientId: import.meta.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: import.meta.env.REACT_APP_AUTH0_AUDIENCE,
  redirectUri: import.meta.env.REACT_APP_AUTH0_REDIRECT_URI,
  logoutUri: import.meta.env.REACT_APP_AUTH0_LOGOUT_URI,
};